@if (isArray(errorMessage)) {
	<div>
		@for (err of errorArray; track err) {
			<div class="mb-1">
				{{ err }}
			</div>
		}
	</div>
}
@if (!isArray(errorMessage)) {
	<div>
		{{ errorString }}
	</div>
}
